import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PaymentForm from '../../../components/forms/PaymentForm';
import { PaymentClient, PaymentDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const PaymentEdit: React.FC = () => {
  const [entityData, setEntityData] = useState<PaymentDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new PaymentClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Payments', href: '/admin/payments' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await apiClient.getPaymentById(id!);
        setEntityData(response.data || null);
      } catch (error) {
        console.error('Error fetching Payment data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      await apiClient.updatePayment(id!, data);
      navigate('/admin/payments');
    } catch (error) {
      console.error('Error updating Payment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Edit Payments"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        {entityData ? (
          <PaymentForm
            initialValues={entityData}
            onCancel={() => navigate('/admin/payments')}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Card>
    </AdminLayout>
  );
};

export default PaymentEdit;
